import React from "react";
import "./WhatsappButton.css";
import icon from "../images/Whatsapp.png";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/918348455548"
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={icon} alt="WhatsApp" />
    </a>
  );
};

export default WhatsAppButton;